import type { CSSProperties, HTMLAttributes } from 'react';

// Wordmark autoritativo: Outfit 700 + tracking -0.04em + punto ambra finale.
// Il punto è la firma del brand. Non eliminarlo mai.
// Fonte: docs/design-system/Audiq Wordmark v3 - Colors.html

const SIZE_MAP = {
  sm: '20px',
  md: '32px',
  lg: '54px',
  xl: '88px',
} as const;

export type AudiqWordmarkSize = keyof typeof SIZE_MAP;

export interface AudiqWordmarkProps extends HTMLAttributes<HTMLSpanElement> {
  size?: AudiqWordmarkSize;
  /** Su sfondi scuri/inverse usa il colore corrente (currentColor) invece di --primary */
  inverse?: boolean;
  /** Mostra solo il wordmark senza punto (es. testo legato in body). Sconsigliato. */
  noDot?: boolean;
}

export function AudiqWordmark({
  size = 'md',
  inverse = false,
  noDot = false,
  className,
  style,
  ...rest
}: AudiqWordmarkProps) {
  const fontSize = SIZE_MAP[size];
  const wordColor = inverse ? 'currentColor' : 'var(--primary)';

  const composedStyle: CSSProperties = {
    fontSize,
    color: wordColor,
    ...style,
  };

  return (
    <span className={`audiq ${className ?? ''}`} style={composedStyle} {...rest}>
      Audiq
      {!noDot && <span style={{ color: 'var(--accent)' }}>.</span>}
    </span>
  );
}
